import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import Timeout = NodeJS.Timeout;
import { Country } from '../../models/Country';
import { LibraryService } from '@core/services/library/library.service';
//import { getCookie } from '@core/utils';

export interface SessionState {
    key: string;
    aesUrl: string;
    userId: string;
    userName: string;
    userRequirePin: boolean;
    userViewForeignApp: boolean;
    language: string;
    countries: Country[];
    sessionId: string;
    refreshInterval: Timeout;
    secKey: string;
    version: string;
    doctorMode: boolean; //CR: Aquí esta bien?
    canViewClinicHistory: boolean; //CR: Aquí esta bien?
    clientContactDataView: boolean;
    otpEnabled: boolean;
    otpCode: string;
    otpRememberMe: boolean;
    otpCookie: string;
    canAddService: boolean;
    canDelService: boolean;
    canAddSlots: boolean;
    canDelSlots: boolean;
}

export function createInitialState(libraryService: LibraryService): SessionState {
    return {
        key: '',
        aesUrl: '',
        userId: '',
        userName: '',
        userRequirePin: false,
        userViewForeignApp: true,
        sessionId: '',
        countries: [],
        language: libraryService.getLanguageCode(),
        refreshInterval: null,
        secKey: 'cRfUjXn2r5u8x/A?',
        version: '',
        doctorMode: false,
        canViewClinicHistory: false,
        clientContactDataView: true,
        otpEnabled: false,
        otpCode: '',
        otpRememberMe: false,
        otpCookie: '',
        canAddService: true,
        canDelService: true,
        canAddSlots: true,
        canDelSlots: true,
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'session' })
export class SessionStore extends Store<SessionState> {
    constructor(private libraryService: LibraryService) {
        super(createInitialState(libraryService));
    }
}
